import { NgFor, NgIf } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatFormField } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatSelect, MatOption } from '@angular/material/select';
import { TranslatePipe } from '@next/core-lib/i18n';
import { Product } from 'src/app/shared/models/shared.model';

import { DosatorConversionTableScheme, DosatorProduct } from '../../models/settings.model';

import { DosatorSettingProductTableComponent } from '../dosator-setting-product-item-table/dosator-setting-product-item-table';

@Component({
  selector: 'app-dosator-setting-product-item',
  templateUrl: './dosator-setting-product-item.html',
  styleUrls: ['./dosator-setting-product-item.scss'],
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatSelect,
    NgFor,
    MatOption,
    DosatorSettingProductTableComponent,
    NgIf,
    MatButton,
    MatIcon,
    TranslatePipe,
  ],
})
export class DosatorSettingProductComponent implements OnInit, AfterViewInit {
  @Input() isMobile: boolean;
  @Input() dosatorProductFormGroup: FormGroup;
  @Input() dosatorProduct: DosatorProduct;
  @Input() products: Product[];
  @Input() index: number;
  @Input() canDelete: boolean;

  @Output() deleteDosatorProduct = new EventEmitter<number>();

  dosatorProducts: Product[];

  conversionFormGroup: FormGroup;

  tableScheme: DosatorConversionTableScheme;

  constructor() {}

  ngOnInit(): void {
    this.conversionFormGroup = this.dosatorProductFormGroup.controls.conversions as FormGroup;
  }

  ngAfterViewInit(): void {
    this.dosatorProducts = this.products;
  }

  public delete() {
    this.deleteDosatorProduct.emit(this.index);
  }
}
